import { twMerge } from "tailwind-merge";
import type { BaseProps, ContainerProps } from "./types";
import { CloseIcon } from "../icons";
import { Column } from "./layout";

export type DialogProps = BaseProps & ContainerProps;

export const Dialog = ({ className, children, ...props }: DialogProps) => {
  return (
    <Column
      className={twMerge(
        "w-[400px] bg-[var(--color-card)] border border-[var(--color-outline)] rounded-lg shadow-2xl leading-6",
        className,
      )}
      onClick={(e) => e.stopPropagation()}
      {...props}
    >
      {children}
    </Column>
  );
};

export type DialogHeaderPops = BaseProps &
  ContainerProps & {
    title: React.ReactNode;
    onClose?: () => void;
  };

export const DialogHeader = ({ className, title, onClose, children, ...props }: DialogHeaderPops) => {
  return (
    <div className={twMerge("flex flex-col px-5 pt-5", className)} {...props}>
      <div className={"flex flex-row justify-between gap-3"}>
        <span className="text-foreground text-lg font-medium">{title}</span>
        {onClose && <CloseIcon onClick={onClose} />}
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};

export const DialogContent = ({ className, children, ...props }: BaseProps & ContainerProps) => {
  return (
    <div className={twMerge("px-5", className)} {...props}>
      {children}
    </div>
  );
};

export const DialogFooter = ({ className, children, ...props }: BaseProps & ContainerProps) => {
  return (
    <div className={twMerge("px-5 pb-5 flex justify-end items-center gap-4", className)} {...props}>
      {children}
    </div>
  );
};
